<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  created() {
    if (this.form.is_vimeo === undefined) {
      this.$set(this.form, 'is_vimeo', false)
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Film z vimeo',
              modelPath: [this, 'form', 'is_vimeo']
            }),
            new fields.Video({
              label: 'Wideo',
              modelPath: [this, 'form', 'video'],
              condition: !this.form.is_vimeo
            }),
            new fields.Input({
              label: 'Link do Vimeo',
              modelPath: [this, 'form', 'video_url'],
              condition: this.form.is_vimeo
            })
          ]
        }
      ]
    }
  }
}
</script>
